export const Contact = {
  EMAIL: 'pya@pya.org',
  TERMS_CONDITIONS: 'https://www.pya.org/info/pya-terms-and-conditions',
};
